import { render, staticRenderFns } from "./PayslipStatementHistory.vue?vue&type=template&id=4f452fe3"
import script from "./PayslipStatementHistory.vue?vue&type=script&lang=js"
export * from "./PayslipStatementHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports